import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { Navigation } from '../components/Navigation';
import { Footer } from '../components/Footer';
import { CookieBanner } from '../components/CookieBanner';
import { useLanguage } from '../contexts/LanguageContext';
const privacyContent = {
  en: {
    title: 'Privacy',
    titleHighlight: 'Policy',
    lastUpdated: 'Last updated: February 3, 2026',
    sections: [{
      title: '1) Who we are',
      content: `it Marker is an IT agency creating modern websites for clients worldwide.

**Data Controller:** Sole Proprietor (FOP) Maksym Pavlovych Tovkach, registered in Ukraine, Tax ID 3606206351.

**Privacy contact:**
- Email: maximtovkach98@gmail.com
- Phone: +380 50 839 93 09

You can also contact us via Telegram/WhatsApp using the contact options on our website.`
    }, {
      title: '2) Scope',
      content: `This Policy applies to:
- visitors of our website;
- people who submit inquiries via our form;
- people who contact us via messenger apps, phone, or email;
- clients who provide materials needed to build a website.`
    }, {
      title: '3) What data we collect',
      content: `**3.1 Data you provide via the website form**
We may collect: Name, Email, Phone number. Optional: Message/comment.
Form submissions may be delivered to us (for example, to a messenger channel) so we can follow up with you.

**3.2 Data you provide for website creation**
If you become a client, you may provide materials and information needed to create your website, such as: project/company name; texts (services, descriptions); images, logo, brand materials; any other files or information you voluntarily send us.
We upload and use these materials only to perform the requested services.

**3.3 Communications**
If you contact us via Telegram/WhatsApp or email, the conversation is stored in the relevant service (messenger/email). We do not delete messages unless requested and unless we are legally required to keep certain records.

**3.4 Technical data and cookies**
When you visit our website, technical data (e.g., IP address, device/browser data, cookies, logs) may be processed to operate the site and ensure reliable delivery.
Our website may be built and/or delivered using third-party services (including AI-assisted website creation tools). Those services may process certain technical data under their own privacy policies.`
    }, {
      title: '4) Why we use your data',
      content: `We process personal data to:
- contact you and respond to your inquiry;
- understand your request and discuss your future website;
- provide a free demo/preview if agreed;
- deliver the service (website creation) and handle revisions;
- keep records required by applicable law (including accounting/tax records under Ukrainian law).`
    }, {
      title: '5) Legal bases',
      content: `Depending on your location, we rely on:
- **Consent** (e.g., checkbox on the form, cookie choices);
- **Pre-contract steps / Contract performance** (to provide the service you request);
- **Legal obligation** (e.g., mandatory accounting/tax record keeping);
- **Legitimate interests** (limited to what is necessary to operate and protect the service).`
    }, {
      title: '6) Cookies and advertising (Google Ads)',
      content: `We use a cookie banner that allows you to accept or decline certain cookies.
We may use Google Ads to promote our services. Depending on your region and settings, this may involve advertising or conversion-measurement cookies. If you decline relevant cookies, we will limit such technologies to the extent possible.`
    }, {
      title: '7) Sharing data with third parties',
      content: `We do not sell personal data.
We may share data only as necessary to provide our services, including:
- communication services (Telegram/WhatsApp) to communicate with you and receive inquiries;
- infrastructure services (e.g., Cloudflare) to deliver site traffic and help route form submissions;
- website creation services (including AI tools, such as Magic Patterns) used to build client projects;
- contractors/employees assigned to your project (only those who actually work on it, and only with necessary access);
- legal disclosures when required by law.`
    }, {
      title: '8) International transfers',
      content: `Because we serve clients worldwide, data may be processed in different countries depending on the services used (e.g., messengers, advertising, infrastructure). Where required, we apply appropriate safeguards.`
    }, {
      title: '9) Payments',
      content: `We do not accept payments directly on the website. Payment details (bank transfer / crypto, etc.) may be provided during personal communication. We do not process or store bank card details on the website.`
    }, {
      title: '10) Data retention',
      content: `We keep communications and client materials as long as necessary for the project and record-keeping. Certain records (e.g., accounting documents) may be retained as required by Ukrainian law.
We delete data manually upon request, unless we must keep it for legal reasons.`
    }, {
      title: '11) Your rights',
      content: `You may contact us to request access, correction, or deletion of your personal data, or to ask us to stop contacting you.
You can withdraw your consent at any time by contacting us using the details above.
For users in the EU/EEA and UK, additional GDPR/UK GDPR rights may apply (access, rectification, erasure, restriction, portability, objection, withdrawal of consent). If you are located in the EU/EEA or the UK, you also have the right to lodge a complaint with your local data protection authority.`
    }, {
      title: '12) Security',
      content: `We use reasonable organizational measures:
- data is controlled by the owner and shared only with the manager/contractor assigned to your project;
- we limit access to what is necessary for delivery.`
    }, {
      title: '13) Children',
      content: `Our services are not intended for children, and we do not knowingly collect children's data.`
    }, {
      title: '14) Call recordings',
      content: `We may occasionally record calls to document agreements. You can ask us to stop recording or delete a recording where feasible and lawful.`
    }, {
      title: '15) Changes',
      content: `Ми можемо оновлювати Політику. Діє актуальна версія, опублікована на сайті.`
    }]
  },
  ru: {
    title: 'Политика',
    titleHighlight: 'конфиденциальности',
    lastUpdated: 'Последнее обновление: 3 февраля 2026',
    sections: [{
      title: '1) Кто мы',
      content: `it Marker — IT-агенция, которая делает современные сайты для клиентов по всему миру.

**Контролёр данных:** ФОП Товкач Максим Павлович (Украина), ИНН 3606206351.

**Контакты по вопросам приватности:**
- Email: maximtovkach98@gmail.com
- Телефон: +380 50 839 93 09

Также можно написать в Telegram/WhatsApp через контакты на нашем сайте.`
    }, {
      title: '2) На кого распространяется',
      content: `Политика применяется к:
- посетителям сайта;
- тем, кто оставляет заявку;
- тем, кто пишет нам в мессенджеры/на почту или звонит;
- клиентам, которые передают материалы для создания сайта.`
    }, {
      title: '3) Какие данные мы собираем',
      content: `**3.1 Данные из формы на сайте**
Мы можем получать: имя, email, номер телефона. По желанию: сообщение/комментарий.
Заявка с сайта может поступать нам (например, в канал коммуникации в мессенджере) для связи с вами.

**3.2 Данные для создания сайта**
Для выполнения услуги клиент может передать: название проекта/компании; тексты (услуги, описания); изображения, логотип, бренд-материалы; любые другие файлы/данные, которые клиент отправляет добровольно.
Мы используем эти материалы только для выполнения работ.

**3.3 Переписка**
Если вы пишете нам в Telegram/WhatsApp или на email, переписка хранится в соответствующем сервисе. Мы не удаляем сообщения, если нет запроса на удаление и если закон не требует хранения некоторых данных.

**3.4 Технические данные и cookies**
При посещении сайта могут обрабатываться технические данные (например, IP-адрес, данные браузера/устройства, cookies, логи) для работы сайта и надёжной доставки контента.
Сайт может использовать сторонние сервисы (в том числе инструменты создания сайтов с использованием ИИ). Такие сервисы могут обрабатывать технические данные согласно своим политикам.`
    }, {
      title: '4) Зачем мы используем данные',
      content: `Данные нужны, чтобы:
- связаться с вами и ответить на заявку;
- обсудить будущий сайт и предложить варианты;
- подготовить бесплатное демо/превью (если договорились);
- выполнить заказ и внести правки;
- хранить документы, если этого требует законодательство Украины (включая бухгалтерию).`
    }, {
      title: '5) Основания обработки',
      content: `В зависимости от страны пользователя мы используем:
- **Согласие** (галочка в форме, выбор cookies);
- **Исполнение договорённости/договора** (когда вы заказываете услугу);
- **Юридическую обязанность** (учёт/налоги);
- **Законный интерес** (в пределах, необходимых для работы и защиты сервиса).`
    }, {
      title: '6) Cookies и реклама (Google Ads)',
      content: `На сайте есть баннер cookies с выбором принять или отклонить.
Мы можем использовать Google Ads для рекламы. Это может включать рекламные и/или конверсионные cookies в зависимости от настроек и требований закона. Если вы отклоняете соответствующие cookies — мы ограничиваем такие технологии в рамках доступных настроек.`
    }, {
      title: '7) Кому мы передаём данные',
      content: `Мы не продаём персональные данные.
Передача возможна только при необходимости:
- Telegram/WhatsApp (для коммуникации и получения заявок);
- инфраструктурные сервисы (например, Cloudflare) для доставки трафика и маршрутизации отправки заявок;
- сервисы создания сайтов (в т.ч. с использованием ИИ, например Magic Patterns) для выполнения клиентских проектов;
- менеджер/исполнитель, назначенный на ваш проект (только нужный доступ);
- по требованию закона.`
    }, {
      title: '8) Международная обработка',
      content: `Так как мы работаем по всему миру, данные могут обрабатываться в разных странах в зависимости от используемых сервисов (мессенджеры, реклама, инфраструктура). При необходимости применяются соответствующие меры защиты.`
    }, {
      title: '9) Оплата',
      content: `Мы не принимаем оплату напрямую на сайте. Реквизиты для оплаты (банковский счёт / крипто и т.д.) могут предоставляться в личном общении. Данные банковских карт на сайте мы не обрабатываем и не храним.`
    }, {
      title: '10) Сроки хранения',
      content: `Переписка и материалы клиента хранятся столько, сколько нужно для проекта и ведения записей. Отдельные документы (например, бухгалтерские/договорные) могут храниться согласно законодательству Украины.
Удаление — вручную по запросу, если нет обязанности хранить данные по закону.`
    }, {
      title: '11) Ваши права',
      content: `Вы можете обратиться к нам, чтобы: получить доступ к данным; исправить данные; удалить данные (если это возможно); попросить перестать с вами связываться.
Вы можете отозвать своё согласие в любой момент, связавшись с нами по контактам выше.
Для пользователей ЕС/ЕЭЗ и Великобритании могут применяться дополнительные права по GDPR/UK GDPR. Если вы находитесь в ЕС/ЕЭЗ или Великобритании, вы также имеете право подать жалобу в местный орган по защите персональных данных.`
    }, {
      title: '12) Безопасность',
      content: `Доступ к данным имеет владелец и, при необходимости, только назначенный менеджер/исполнитель проекта. Доступ ограничивается объёмом, необходимым для выполнения работ.`
    }, {
      title: '13) Дети',
      content: `Наши услуги не предназначены для детей. Мы намеренно не собираем данные детей.`
    }, {
      title: '14) Запись звонков',
      content: `Иногда звонки могут записываться для фиксации договорённостей. Вы можете попросить не записывать или удалить запись, если это возможно и законно.`
    }, {
      title: '15) Изменения',
      content: `Мы можем обновлять Политику. Действует актуальная версия, опубликованная на сайте.`
    }]
  },
  ua: {
    title: 'Політика',
    titleHighlight: 'конфіденційності',
    lastUpdated: 'Останнє оновлення: 3 лютого 2026',
    sections: [{
      title: '1) Хто ми',
      content: `it Marker — IT-агенція, яка створює сучасні сайти для клієнтів по всьому світу.

**Володілець даних (контролер):** ФОП Товкач Максим Павлович (Україна), ІПН 3606206351.

**Контакти з питань приватності:**
- Email: maximtovkach98@gmail.com
- Телефон: +380 50 839 93 09

Також можна звернутися через Telegram/WhatsApp через контакти на нашому сайті.`
    }, {
      title: '2) На кого поширюється',
      content: `Політика застосовується до:
- відвідувачів сайту;
- осіб, які залишають заявку;
- осіб, які пишуть нам у месенджери/на пошту або телефонують;
- клієнтів, які передають матеріали для створення сайту.`
    }, {
      title: '3) Які дані ми збираємо',
      content: `**3.1 Дані з форми на сайті**
Ми можемо отримувати: Ім'я, Email, Номер телефону. За бажанням: Повідомлення/коментар.
Заявка з сайту може надходити нам (наприклад, у канал комунікації в месенджері) для подальшого зв'язку.

**3.2 Дані для створення сайту**
Для виконання послуги клієнт може передати: назву проєкту/компанії; тексти (послуги, описи); зображення, логотип, бренд-матеріали; інші файли/дані, які клієнт надсилає добровільно.
Ми використовуємо ці матеріали лише для виконання замовлення.

**3.3 Переписка**
Якщо ви пишете нам у Telegram/WhatsApp або на email, переписка зберігається у відповідному сервісі. Ми не видаляємо повідомлення, якщо немає запиту на видалення та якщо закон не зобов'язує нас зберігати певні дані.

**3.4 Технічні дані та cookies**
Під час відвідування сайту можуть оброблятися технічні дані (наприклад, IP-адреса, дані браузера/пристрою, cookies, журнали) для роботи сайту та надійної доставки контенту.
Сайт може працювати на сторонніх сервісах (у т.ч. інструментах створення сайтів з використанням ШІ). Такі сервіси можуть обробляти технічні дані відповідно до власних політик.`
    }, {
      title: '4) Для чого ми використовуємо дані',
      content: `Дані потрібні, щоб:
- зв'язатися з вами та відповісти на заявку;
- обговорити ваш майбутній сайт і запропонувати варіанти;
- підготувати безкоштовне демо/попередній варіант (якщо домовлено);
- виконати замовлення та вести правки;
- зберігати документи, якщо цього вимагає законодавство України (в т.ч. бухгалтерія).`
    }, {
      title: '5) Підстави обробки',
      content: `Ми використовуємо:
- **Згоду** (галочка в формі, вибір cookies);
- **Виконання домовленості/договору** (коли ви замовляєте послугу);
- **Юридичний обов'язок** (облік/податки);
- **Законний інтерес** (у межах, необхідних для роботи та захисту сервісу).`
    }, {
      title: '6) Cookies та реклама (Google Ads)',
      content: `На сайті є банер cookies із вибором прийняти або відхилити.
Ми можемо використовувати Google Ads для реклами. Це може включати рекламні та/або конверсійні cookies залежно від налаштувань і вимог закону. Якщо ви відхиляєте відповідні cookies — ми обмежуємо такі технології в межах доступних налаштувань.`
    }, {
      title: '7) Передача даних третім сторонам',
      content: `Ми не продаємо персональні дані.
Дані можуть передаватися лише за потреби для роботи:
- Telegram/WhatsApp (для комунікації та отримання заявок);
- інфраструктурні сервіси (наприклад, Cloudflare) для доставки трафіку та маршрутизації відправки заявок;
- сервіси створення сайтів (у т.ч. з використанням ШІ, наприклад Magic Patterns) для виконання клієнтських проєктів;
- менеджер/виконавець, який призначений на ваш проєкт (лише необхідний доступ);
- у випадках, коли цього вимагає закон.`
    }, {
      title: '8) Міжнародна обробка',
      content: `Оскільки ми працюємо по всьому світу, дані можуть оброблятися в різних країнах залежно від сервісів (месенджери, реклама, інфраструктура). За потреби застосовуються відповідні механізми захисту.`
    }, {
      title: '9) Оплата',
      content: `Ми не приймаємо оплату безпосередньо на сайті. Реквізити для оплати (банківський переказ / крипто тощо) можуть надаватися під час особистого спілкування. Дані банківських карток на сайті ми не обробляємо та не зберігаємо.`
    }, {
      title: '10) Строки зберігання',
      content: `Переписка та матеріали клієнта зберігаються стільки, скільки потрібно для проєкту та ведення записів. Окремі документи (наприклад, бухгалтерські) можуть зберігатися відповідно до законодавства України.
Видалення — вручну за запитом, якщо немає юридичного обов'язку зберігати.`
    }, {
      title: '11) Ваші права',
      content: `Ви можете звернутися до нас, щоб: отримати доступ до даних; виправити дані; видалити дані (якщо це можливо); попросити припинити зв'язок з вами.
Ви можете відкликати свою згоду в будь-який момент, зв'язавшись з нами за контактами вище.
Для користувачів ЄС/ЄЕЗ і Великої Британії можуть діяти додаткові права за GDPR/UK GDPR. Якщо ви перебуваєте в ЄС/ЄЕЗ або Великій Британії, ви також маєте право подати скаргу до місцевого органу з питань захисту персональних даних.`
    }, {
      title: '12) Безпека',
      content: `Доступ до даних має власник і, за потреби, лише призначений менеджер/виконавець проєкту. Доступ обмежується обсягом, необхідним для виконання робіт.`
    }, {
      title: '13) Діти',
      content: `Послуги не призначені для дітей. Ми свідомо не збираємо дані дітей.`
    }, {
      title: '14) Запис дзвінків',
      content: `Іноді дзвінки можуть записуватися для фіксації домовленостей. Ви можете попросити не записувати або видалити запис, якщо це можливо та законно.`
    }, {
      title: '15) Зміни',
      content: `Ми можемо оновлювати Політику. Діє актуальна версія, опублікована на сайті.`
    }]
  },
  pl: {
    title: 'Polityka',
    titleHighlight: 'prywatności',
    lastUpdated: 'Ostatnia aktualizacja: 3 lutego 2026',
    sections: [{
      title: '1) Kim jesteśmy',
      content: `it Marker to agencja IT, która tworzy nowoczesne strony internetowe dla klientów na całym świecie.

**Administrator danych:** jednoosobowa działalność (FOP) Maksym Pawłowycz Towkach (Ukraina), ID 3606206351.

**Kontakt w sprawach prywatności:**
- Email: maximtovkach98@gmail.com
- Telefon: +380 50 839 93 09

Możesz też skontaktować się z nami przez Telegram/WhatsApp poprzez kontakty na naszej stronie.`
    }, {
      title: '2) Zakres',
      content: `Polityka dotyczy:
- odwiedzających stronę;
- osób wysyłających zapytania przez formularz;
- osób kontaktujących się z nami przez komunikatory, telefon lub email;
- klientów przekazujących materiały do wykonania strony.`
    }, {
      title: '3) Jakie dane zbieramy',
      content: `**3.1 Dane z formularza**
Możemy zbierać: imię, email, numer telefonu. Opcjonalnie: wiadomość/komentarz.
Zgłoszenie z formularza może trafiać do nas (np. do kanału komunikacji w komunikatorze), abyśmy mogli się z Tobą skontaktować.

**3.2 Dane do wykonania strony**
Klient może przekazać nam materiały niezbędne do realizacji projektu, np.: nazwę firmy/projektu; teksty (usługi, opisy); zdjęcia, logo, materiały brandingowe; inne pliki/informacje przekazane dobrowolnie.
Wykorzystujemy te materiały wyłącznie do realizacji usługi.

**3.3 Komunikacja**
Jeżeli kontaktujesz się z nami przez Telegram/WhatsApp lub email, rozmowa jest przechowywana w danym serwisie. Nie usuwamy wiadomości, chyba że poprosisz o usunięcie i nie ma obowiązku prawnego ich przechowywania.

**3.4 Dane techniczne i pliki cookies**
Podczas korzystania ze strony mogą być przetwarzane dane techniczne (np. adres IP, dane przeglądarki/urządzenia, cookies, logi) w celu działania strony i niezawodnego dostarczania treści.
Strona może wykorzystywać usługi zewnętrzne (w tym narzędzia do tworzenia stron z użyciem AI). Takie usługi mogą przetwarzać dane techniczne zgodnie z własnymi politykami.`
    }, {
      title: '4) W jakim celu przetwarzamy dane',
      content: `Dane przetwarzamy, aby:
- skontaktować się i odpowiedzieć na zapytanie;
- ustalić wymagania i zaproponować możliwe warianty strony;
- przygotować darmowe demo/podgląd (jeśli ustalone);
- zrealizować usługę i wprowadzać poprawki;
- przechowywać dokumenty wymagane prawem Ukrainy (w tym księgowe).`
    }, {
      title: '5) Podstawy prawne',
      content: `W zależności od kraju użytkownika stosujemy:
- **Zgodę** (checkbox w formularzu, wybór cookies);
- **Działania przed zawarciem umowy / realizację umowy** (gdy zamawiasz usługę);
- **Obowiązek prawny** (np. księgowość/podatki);
- **Uzasadniony interes** (w zakresie niezbędnym do działania i ochrony usługi).`
    }, {
      title: '6) Cookies i reklama (Google Ads)',
      content: `Na stronie działa baner cookies z opcją zaakceptuj lub odrzuć.
Możemy korzystać z Google Ads w celach reklamowych. Może to obejmować pliki cookies reklamowe i/lub pomiar konwersji, zależnie od ustawień i wymogów prawnych. Jeśli odrzucisz odpowiednie cookies — ograniczymy te technologie w miarę możliwości.`
    }, {
      title: '7) Udostępnianie danych',
      content: `Nie sprzedajemy danych osobowych.
Dane mogą być przekazywane wyłącznie, gdy jest to potrzebne do działania:
- Telegram/WhatsApp (kontakt i obsługa zapytań);
- usługi infrastrukturalne (np. Cloudflare) do dostarczania ruchu i przekazywania zgłoszeń;
- usługi tworzenia stron (także z użyciem AI, np. Magic Patterns) do realizacji projektów klienta;
- przypisany menedżer/wykonawca projektu (tylko niezbędny dostęp);
- gdy wymagają tego przepisy prawa.`
    }, {
      title: '8) Transfery międzynarodowe',
      content: `Ponieważ działamy globalnie, dane mogą być przetwarzane w różnych krajach w zależności od użytych usług (komunikatory, reklama, infrastruktura). W razie potrzeby stosujemy odpowiednie zabezpieczenia.`
    }, {
      title: '9) Płatności',
      content: `Nie przyjmujemy płatności bezpośrednio na stronie. Dane do płatności (przelew / krypto itp.) mogą być przekazane podczas rozmowy. Nie przetwarzamy ani nie przechowujemy danych kart płatniczych na stronie.`
    }, {
      title: '10) Okres przechowywania',
      content: `Komunikacja i materiały klienta są przechowywane tak długo, jak to potrzebne do projektu i prowadzenia dokumentacji. Dokumenty księgowe/umowne przechowujemy zgodnie z prawem Ukrainy.
Usuwamy dane ręcznie na żądanie, o ile nie istnieje obowiązek prawny ich przechowywania.`
    }, {
      title: '11) Twoje prawa',
      content: `Możesz skontaktować się z nami, aby: uzyskać dostęp do danych; poprawić dane; usunąć dane (jeśli to możliwe); poprosić o zaprzestanie kontaktu.
Możesz w każdej chwili wycofać zgodę, kontaktując się z nami za pomocą danych powyżej.
Dla osób z UE/EOG oraz Wielkiej Brytanii mogą obowiązywać dodatkowe prawa wynikające z GDPR/UK GDPR. Jeśli znajdujesz się w UE/EOG lub w Wielkiej Brytanii, masz również prawo złożyć skargę do lokalnego organu ochrony danych.`
    }, {
      title: '12) Bezpieczeństwo',
      content: `Dostęp do danych ma właściciel oraz — jeśli to konieczne — tylko przypisany menedżer/wykonawca projektu. Dostęp ograniczamy do minimum potrzebnego do realizacji usługi.`
    }, {
      title: '13) Dzieci',
      content: `Nasze usługi nie są przeznaczone dla dzieci. Nie zbieramy świadomie danych dzieci.`
    }, {
      title: '14) Nagrywanie rozmów',
      content: `Czasami rozmowy mogą być nagrywane w celu potwierdzenia ustaleń. Możesz poprosić o nienagrywanie lub usunięcie nagrania, jeśli to możliwe i zgodne z prawem.`
    }, {
      title: '15) Zmiany',
      content: `Możemy aktualizować Politykę. Obowiązuje aktualna wersja opublikowana na stronie.`
    }]
  }
};
export function PrivacyPage() {
  const {
    language
  } = useLanguage();
  const content = privacyContent[language] || privacyContent.en;
  // Simple markdown-like formatting
  const formatContent = (text: string) => {
    return text.split('\n').map((line, i) => {
      // Bold text
      const formattedLine = line.replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>');
      if (line.startsWith('- ')) {
        return <li key={i} className="ml-4" dangerouslySetInnerHTML={{
          __html: formattedLine.substring(2)
        }} data-id="element-725" />;
      }
      if (line.trim() === '') {
        return <br key={i} data-id="element-726" />;
      }
      return <p key={i} className="mb-2" dangerouslySetInnerHTML={{
        __html: formattedLine
      }} data-id="element-727" />;
    });
  };
  return <div className="min-h-screen w-full" style={{
    backgroundColor: 'var(--bg-primary)'
  }} data-id="element-728">
      <Navigation data-id="element-729" />

      <div className="pt-32 pb-20 px-4" data-id="element-730">
        <div className="max-w-4xl mx-auto" data-id="element-731">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} data-id="element-732">
            <h1 className="text-4xl sm:text-5xl font-bold mb-4" style={{
            color: 'var(--text-primary)'
          }} data-id="element-733">
              {content.title}{' '}
              <span style={{
              color: 'var(--accent)'
            }} data-id="element-734">
                {content.titleHighlight}
              </span>
            </h1>
            <p className="text-sm mb-8" style={{
            color: 'var(--text-muted)'
          }} data-id="element-735">
              {content.lastUpdated}
            </p>

            <div className="space-y-6" data-id="element-736">
              {content.sections.map((section, index) => <motion.div key={index} initial={{
              opacity: 0,
              y: 20
            }} animate={{
              opacity: 1,
              y: 0
            }} transition={{
              duration: 0.4,
              delay: index * 0.05
            }} className="rounded-2xl border p-6 sm:p-8" style={{
              borderColor: 'var(--border)',
              backgroundColor: 'var(--bg-secondary)'
            }} data-id="element-737">
                  <h2 className="text-lg sm:text-xl font-bold mb-4" style={{
                color: 'var(--text-primary)'
              }} data-id="element-738">
                    {section.title}
                  </h2>
                  <div className="text-sm sm:text-base leading-relaxed [&>ul]:list-disc [&>ul]:ml-4 [&>ul]:space-y-1 [&_strong]:font-semibold" style={{
                color: 'var(--text-secondary)'
              }} data-id="element-739">
                    {formatContent(section.content)}
                  </div>
                </motion.div>)}
            </div>
          </motion.div>
        </div>
      </div>

      <Footer data-id="element-740" />
      <CookieBanner data-id="element-741" />
    </div>;
}